module.exports = __webpack_public_path__ + "img/sun-icon.4744e4ea.png";